<div class="dashboard-wrapper">
  <div class="top-bar">
    <div class="selection-container">
      <ng-content *ngIf="displaySelectionPanel">
        <app-brands-selection-panel [displayUserRelatedBrand]="displayUserRelatedBrand"
          [isMyCompetitorsDisabled]="myCompetitorsDisabled"
          [isTrialUser]="isTrialUser"
          [shouldDisplayAddButton]="shouldDisplayAddButton()"
          [shouldDisplayRemoveButton]="shouldDisplayRemoveButton()"
          [userRelatedBrand]="!displayUserRelatedBrand ? undefined : userRelatedBrand()"
          [userRelatedBrandOptions]="!displayUserRelatedBrand ? undefined : userRelatedBrandOptions()"
          [myBrand]="!displayUserRelatedBrand ? myBrand() : undefined"
          [myCompetitors]="!displayUserRelatedBrand ? myCompetitors() : undefined"
          [myBrandOptions]="!displayUserRelatedBrand ? myBrandOptions() : undefined"
          [myCompetitorsOptions]="!displayUserRelatedBrand ? myCompetitorsOptions() : undefined"
          (brandChanged)="onMyBrandChanged($event)" (competitorChanged)="onCompetitorChanged($event)"
          (competitorAdded)="onCompetitorAdded($event)" (competitorRemoved)="onCompetitorRemoved($event)"
          (userRelatedBrandChanged)="onUserRelatedBrandChanged($event)"></app-brands-selection-panel>
      </ng-content>
      <div class="my-campaigns-container">
        <ng-content select="[campaignSelection]"></ng-content>
        <ng-content select="[creativeSelection]"></ng-content>
      </div>
    </div>
    <div class="filters-container" *ngIf="!this.stateService.isRouterOutletScrolledToTop() && !this.displaySecondBar">
      <button class="additional-filters-button" (click)="toggleDisplaySecondBar()">
        <span class="icon-badge-container">
          <img [src]="'svg/filters.svg' | assetVersion">
          <span class="badge-dot"
            *ngIf="countriesControl.value?.length || deviceControl.value !== DeviceFilterType.ALL_DEVICES || platformControl.value?.length"></span>
        </span>
        Additional Filters
      </button>
      <app-date-picker [range]="dateRangeGroup" (dateRangeSelected)="onDateRangeChange($event!)"></app-date-picker>
    </div>
  </div>
  <div class="second-bar" [class.opened]="(this.stateService.isRouterOutletScrolledToTop()) || (this.displaySecondBar)">
    <div class="filters-container">
      <app-select-menu *ngIf="this.type === DashboardType.SOCIAL_OVERVIEW" [selectMode]="SelectMode.MULTI"
        [iconPath]="'svg/Hashtag.svg'" [items]="platformOptions" [placeholder]="'All Platforms'"
        [control]="platformControl" [width]="'170px'" [dropDownWideWidth]="true" [showPlaceholderIcon]="true"
        [selectAllAndClearOptions]="true" [groupBySelected]="true" (onApply)="onPlatformChange()">
      </app-select-menu>
      <app-select-menu *ngIf="this.type !== DashboardType.SOCIAL_OVERVIEW" [attr.data-testid]="DataTestIds.COUNTRIES_FILTER"
        [disabled]="this.type === DashboardType.AI_PRESENCE" [selectMode]="SelectMode.MULTI"
        [iconPath]="'svg/globe.svg'" [iconStyle]="{ 'border-radius': '50%', 'object-fit': 'cover' }"
        [items]="countriesOptions()" [placeholder]="'All Countries'" [control]="countriesControl" [width]="'170px'"
        [dropDownWideWidth]="true" [showPlaceholderIcon]="true" [searchable]="true" [selectAllAndClearOptions]="true"
        [groupBySelected]="true" (onApply)="onCountryChange()">
      </app-select-menu>
      <app-select-menu *ngIf="this.type !== DashboardType.SOCIAL_OVERVIEW" [attr.data-testid]="DataTestIds.DEVICE_FILTER"
        [disabled]="this.type === DashboardType.AI_PRESENCE" [selectMode]="SelectMode.SINGLE"
        [iconPath]="'svg/all-devices.svg'" [items]="deviceOptions" [placeholder]="'All Devices'"
        [control]="deviceControl" [width]="'170px'" [showSelectedIcon]="true" (onApply)="onDeviceChange()">
      </app-select-menu>
      <app-date-picker [attr.data-testid]="DataTestIds.DATE_PICKER" [range]="dateRangeGroup"
        (dateRangeSelected)="onDateRangeChange($event!)">
      </app-date-picker>
      <img [src]="'svg/sort-arrow.svg' | assetVersion" class="arrow-button"
        *ngIf="!this.stateService.isRouterOutletScrolledToTop()" (click)="toggleDisplaySecondBar()">
    </div>
  </div>
  <ng-content select="[dashboard]"></ng-content>
</div>
